import {
  IEmployeeSearchReportRequest,
  IEmployeesService,
} from "@/services/backend/sol_customer/employees/employees.types";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { APPLICATION_JSON } from "@/constans";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class EmployeesService implements IEmployeesService {
  async postGenerateEmployeeSearchReport(request?: IEmployeeSearchReportRequest): Promise<void> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/report/employee-search`, request, {
        headers,
      })
    );

    if (error) {
      return undefined;
    }
  }
}
